module.exports = __webpack_public_path__ + "static/media/topTriangle.cbf8ce56.svg";